import { ListFilterWrapper } from './style';
import React from 'react';

const ListFilter = ({
  totalCount = 0,
  setFilterData,
  filterData = {},
  selectDataList = [
    {
      name: '',
      placeholder: '',
      optionList: [{ label: '', value: '' }],
      disabled: false,
      width: '100px',
    },
  ],
}) => {
  const onChangeSelect = (event, item) => {
    setFilterData(prev => ({
      ...prev,
      [item.name]: event.target.value,
    }));
  };

  return (
    <ListFilterWrapper>
      <span>총 {totalCount} 개</span>
      <div className="selectGroup">
        {selectDataList.map((item, index) => (
          <select
            key={`select_${index}`}
            onChange={event => onChangeSelect(event, item)}
            value={
              filterData && filterData[item.name] ? filterData[item.name] : ''
            }
            disabled={item.disabled}
            style={{ width: `${item.width}` }}
            name={item.name}
          >
            {item.placeholder && (
              <option defaultValue value="">
                {item.placeholder}
              </option>
            )}
            {item.optionList?.map((optItem, index) => {
              return (
                <option
                  key={`selectList_${optItem.value}_${index}`}
                  value={optItem.value}
                >
                  {optItem.label}
                </option>
              );
            })}
          </select>
        ))}
      </div>
    </ListFilterWrapper>
  );
};

export default ListFilter;
